module.exports = __webpack_public_path__ + "img/home_training.a86c0b2e.jpg";